<template>
    <div class="basicData" v-wechat-title="$t('添加/编辑功能角色')">
        <Title :title="$t('添加/编辑功能角色')"/>
        <div class="form_box">
            <div class="common_title add_account">{{ $t('角色基本信息') }}</div>
            <div class="form_box_line">
                <div class="form_box_line_item">
                    <div class="input_title"><span class="has_must">{{ $t('角色名称') }}</span></div>
                    <div class="input_box">
                        <el-input  v-model.trim="parameters.name" clearable maxLength="15"></el-input>
                    </div>
                </div>
            </div>
        </div>
        <div class="btn_box">
            <button type="button" class="back_btn" @click="$router.go(-1)">{{ $t('返回') }}</button>
            <button type="button" class="save_btn" @click="save" v-permissions="26020302" v-noClick>{{ $t('保存') }}</button>
        </div>
        <div class="common_title account_role">{{ $t('功能模块') }}</div>
        <div class="tree_box" v-if="treeList.length > 0">
            <el-tree ref="tree"
                     :data="treeList"
                     show-checkbox
                     :props="defaultProps"
                     node-key="id"
                     @check="check"
                     :check-strictly="isTrue"
                     :check-on-click-node="true"
                     :expand-on-click-node="false"
            ></el-tree>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                parameters: {
                    id: '',
                    name: '',
                    functionIds: ''
                },
                treeList: [],
                defaultProps: {
                    children: 'children',
                    label: 'name'
                },
                isTrue: false
            }
        },
        mounted () {
            this.initMounted()
        },
        methods: {
            initMounted () {
                this.getTenantFunctionTreeList()
                if (this.$route.query.id) {
                    setTimeout(this.read, 100)
                }
            },
            check(data) {
                console.log(data.id, '当前点击权限id')
                if (data.level === 2) this.$refs.tree.setChecked(data.parentId, true, false)
                if (data.level === 3) {
                    let Node = this.$refs.tree.getNode(data.id)
                    this.$refs.tree.setChecked(data.parentId, true, false)
                    this.$refs.tree.setChecked( Node.parent.parent.key, true, false)
                }
                if (data.level === 4) {
                    let Node = this.$refs.tree.getNode(data.id)
                    this.$refs.tree.setChecked(data.parentId, true, false)
                    this.$refs.tree.setChecked( Node.parent.parent.key, true, false)
                    this.$refs.tree.setChecked( Node.parent.parent.parent.key, true, false)
                }
                this.parameters.functionIds = this.$refs.tree.getCheckedKeys().concat(this.$refs.tree.getHalfCheckedKeys()).join(',')
            },
            save () {
                if (!this.parameters.name) {
                    this.$message.info(this.$t('请输入') + this.$t('角色名称'))
                    return false
                }
                if (!this.parameters.functionIds) {
                    this.$message.info(this.$t('请选择') + this.$t('功能模块'))
                    return false
                }
                this.$store.dispatch(this.$route.query.id ? 'a:maintainFunctionRole/update' : 'a:maintainFunctionRole/create', this.parameters).then(
                    res => {
                        this.$message.success(this.$t('保存成功'));
                        this.$router.go(-1)
                    },
                    rej => {
                        this.$message.error(rej.errorInfo);
                    }
                )
            },
            read () {
                this.$store.dispatch('a:maintainFunctionRole/read', {id: this.$route.query.id}).then(
                    res => {
                        this.parameters = res
                        this.isTrue = true
                        setTimeout(() => {
                            for (let item of res.functionIds.split(',')) {
                                this.$refs.tree.setChecked(item, true, false)
                            }
                            setTimeout(() => {
                                this.isTrue = false
                            }, 300)
                        }, 300)
                    },
                    rej => {
                        this.$message.error(rej.errorInfo);
                    }
                )
            },
            getTenantFunctionTreeList () {
                this.$store.dispatch('a:maintainFunctionRole/getTenantFunctionTreeList').then(
                    res => {
                        this.treeList = res
                    },
                    rej => {
                        this.$message.error(rej.errorInfo);
                    }
                )
            }
        }
    }
</script>

<style lang="scss" scoped>

    .account_role {
        background: #EFF3F6 url("~img/common/account-role.png") no-repeat 44px;
        background-size: 26px;
    }
    .tree_box {
        padding: 10px 40px;
    }
</style>
